webpackJsonp([62],{

/***/ "yTSi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-payment-details-enter-card_4c4c9a6bbcbc07590ae14e93d3dde880.html";

/***/ }),

/***/ "z6GX":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionPaymentDetailsEnterCard = (function () {
    function SubscriptionPaymentDetailsEnterCard() {
    }
    return SubscriptionPaymentDetailsEnterCard;
}());
angular.module('animatronApp.SubscriptionPaymentDetailsEnterCard', [])
    .component('subscriptionPaymentDetailsEnterCard', {
    controller: SubscriptionPaymentDetailsEnterCard,
    templateUrl: __webpack_require__("yTSi")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/62-40ecf89b893baa28ab63.min.js